import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { BlocksContent, BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Slash } from "lucide-react";

export interface TnCProps {
  content: BlocksContent;
  updatedAt: string
}

export default function TnCContent(props: TnCProps) {
  return (
    <div className="bg-coffebrown w-full pt-10 xl:pt-[80px]">
      <div className="w-full xl:max-w-screen-xl mx-auto px-8 xl:px-0 pt-20 xl:pt-44">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink className="font-karbon xl:text-2xl text-white" href="/">Home</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="mx-1">
              <Slash color="white" />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink className="font-karbon xl:text-2xl text-white" href="/terms-conditions">Term and Conditions</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <p className="text-gold font-pluto text-3xl xl:text-5xl mt-12">Term and Conditions</p>

        <p className="text-white font-karbon mt-4 mb-20 xl:text-[1.75rem]">
          Last modified on {props.updatedAt}
        </p>

        <div className="whitespace-normal text-white font-karbon xl:text-2xl pb-44 revert-all">
        <BlocksRenderer content={props.content} />
        </div>
      </div>
    </div>
  );
}
